import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n"
import { ConfigProvider } from './Context/ConfigContext';
import { Provider } from 'react-redux';
import { store } from './Redux/Store/store';
import { Loader } from './Components/Loader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ConfigProvider>
      <React.Suspense fallback={Loader}>
        <App />
      </React.Suspense>
    </ConfigProvider>
  </Provider>
);

reportWebVitals();
